import { eventChannel } from 'redux-saga';
import { takeEvery, put, select } from 'redux-saga/effects';
import { initHistory, goTo, back } from '../engine/actions/HistoryActions';
import { sagaCreator, stateSelector } from 'redux-saga-kit';
import { FLOW_STEP } from '../engine/reducers/SessionReducer';
import { popFromHistoryStack, pushToHistoryStack, init as initSession } from '../engine/actions/SessionActions';
import BILogger from '../../utils/BILogger';

const appName = 'restaurants-call-center';

const onInit = ({ history, unhideSidebar }) =>
  function* () {
    const step = yield select(stateSelector('session.step'));
    yield takeEvery(historyChannel(history), onHistoryChange({ history, unhideSidebar }));
    if (step && step !== FLOW_STEP.INIT) {
      yield put(pushToHistoryStack({ step }));
    }
  };

// This is needed to solve an issue with back navigation
const onInitSession = ({ history }) =>
  function () {
    setTimeout(() => {
      history.push({
        pathname: history.location.pathname,
        search: history.location.search,
        state: appName,
      });
    });
  };

const onGoTo = ({ hideSidebar, unhideSidebar }) =>
  function* ({ payload }) {
    const { state } = payload;
    const { step } = state;

    if (step === FLOW_STEP.IDLE) {
      hideSidebar();
    } else if (step === FLOW_STEP.INIT) {
      unhideSidebar();
    }

    yield put(pushToHistoryStack({ step }));
  };

const onBack = () =>
  function* () {
    yield put(popFromHistoryStack());
  };

function* onHistoryStackChange() {
  const organizationId = yield select(stateSelector('session.organization.id'));
  const pageName = yield select(stateSelector('session.step'));
  BILogger.navigationPage({ organizationId, pageName });
}

/// /////////// effects

const onHistoryChange = ({ history, unhideSidebar }) =>
  function* ({ action }) {
    if (action === 'POP') {
      yield put(popFromHistoryStack());

      const step = yield select(stateSelector('session.step'));

      if (step !== FLOW_STEP.INIT) {
        history.push({
          pathname: history.location.pathname,
          search: history.location.search,
          state: appName,
        });
      } else {
        unhideSidebar();
      }
    }
  };

function historyChannel(history) {
  return eventChannel((emitter) => {
    return history.listen((location, action) => {
      if (location.pathname.indexOf(appName) >= 0) {
        emitter({ location, action });
      }
    });
  });
}

/// default export
export default sagaCreator({
  [initHistory]: { handler: onInit },
  [initSession]: { handler: onInitSession },
  [goTo]: { handler: onGoTo },
  [back]: { handler: onBack },
  [pushToHistoryStack]: { handler: onHistoryStackChange, noParams: true },
  [popFromHistoryStack]: { handler: onHistoryStackChange, noParams: true },
});
